import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import styles from './FiltersContainer.module.scss';
import FiltersHeader from '../FiltersHeader';

type FiltersContainerProps = {
	children: ReactNode;
	changeVisibilityFilters: () => void;
	resetForm: () => void;
	isCloseFilters: boolean;
	isOrgFilter?: boolean;
	isNewDashboard?: boolean;
};

const FiltersContainer: FC<FiltersContainerProps> = ({
	children,
	changeVisibilityFilters,
	isCloseFilters,
	isOrgFilter,
	resetForm,
	isNewDashboard,
}: FiltersContainerProps) => {
	return (
		<div
			className={cx(styles.main, {
				[styles.close]: isCloseFilters,
				[styles.orgStyle]: isOrgFilter,
				[styles.newDashboard]: isNewDashboard,
			})}
		>
			<div className={styles.content}>
				<FiltersHeader
					changeVisibilityFilters={changeVisibilityFilters}
					resetForm={resetForm}
					isNewDashboard={isNewDashboard}
				/>
				{!isCloseFilters && <hr className={styles.separator} />}
				<div className={styles.content__filters}>{children}</div>
			</div>
		</div>
	);
};

export default FiltersContainer;
